export const BeCountriesAndCurrencies = [
  {
    CountryCode: 'US',
    icon: '/bee2-ui/img/flags/us.png',
    CurrencyCode: 'USD',
    CountryName: 'United States',
    CultureProgId: 'en-GB',
  },
  {
    CountryCode: 'CA',
    icon: '/bee2-ui/img/flags/ca.png',
    CurrencyCode: 'CAD',
    CountryName: 'Canada',
    CultureProgId: 'en-GB',
  },
  {
    CountryCode: 'GB',
    icon: '/bee2-ui/img/flags/gb.png',
    CurrencyCode: 'GBP',
    CountryName: 'United Kingdom',
    CultureProgId: 'en-GB',
  },
  {
    CountryCode: 'AU',
    icon: '/bee2-ui/img/flags/au.png',
    CurrencyCode: 'AUD',
    CountryName: 'Australia',
    CultureProgId: 'en-GB',
  },
];

export const GeCountriesAndCurrencies = [
  {
    CountryName: 'Albania',
    CountryCode: 'AL',
    CurrencyName: 'Lek',
    CurrencySymbol: 'ALL',
    CurrencyCode: 'ALL',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Algeria',
    CountryCode: 'DZ',
    CurrencyName: 'Algerian Dinar',
    CurrencySymbol: 'DA',
    CurrencyCode: 'DZD',
    CultureProgId: 'ar',
    CultureName: 'Arabic',
  },
  {
    CountryName: 'American Samoa',
    CountryCode: 'AS',
    CurrencyName: 'US Dollar',
    CurrencySymbol: '$',
    CurrencyCode: 'USD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Angola',
    CountryCode: 'AO',
    CurrencyName: 'Kwanza',
    CurrencySymbol: 'Kz',
    CurrencyCode: 'AOA',
    CultureProgId: 'pt',
    CultureName: 'Portuguese',
  },
  {
    CountryName: 'Anguilla',
    CountryCode: 'AI',
    CurrencyName: 'East Caribbean Dollar',
    CurrencySymbol: 'EC$',
    CurrencyCode: 'XCD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Antigua and Barbuda',
    CountryCode: 'AG',
    CurrencyName: 'East Caribbean Dollar',
    CurrencySymbol: 'EC$',
    CurrencyCode: 'XCD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Armenia',
    CountryCode: 'AM',
    CurrencyName: 'Armenian Dram',
    CurrencySymbol: 'AMD',
    CurrencyCode: 'AMD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Aruba',
    CountryCode: 'AW',
    CurrencyName: 'Aruban Florin',
    CurrencySymbol: 'Afl.',
    CurrencyCode: 'AWG',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Australia',
    CountryCode: 'AU',
    CurrencyName: 'Australian Dollar',
    CurrencySymbol: 'AU$',
    CurrencyCode: 'AUD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Austria',
    CountryCode: 'AT',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'de-AT',
    CultureName: 'German - Austria',
  },
  {
    CountryName: 'Azerbaijan',
    CountryCode: 'AZ',
    CurrencyName: 'Azerbaijanian Manat',
    CurrencySymbol: 'man.',
    CurrencyCode: 'AZN',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Bahamas',
    CountryCode: 'BS',
    CurrencyName: 'Bahamian Dollar',
    CurrencySymbol: 'BS$',
    CurrencyCode: 'BSD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Bahrain',
    CountryCode: 'BH',
    CurrencyName: 'Bahraini Dinar',
    CurrencySymbol: 'BD',
    CurrencyCode: 'BHD',
    CultureProgId: 'ar',
    CultureName: 'Arabic',
  },
  {
    CountryName: 'Barbados',
    CountryCode: 'BB',
    CurrencyName: 'Barbados Dollar',
    CurrencySymbol: 'Bds$',
    CurrencyCode: 'BBD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Belize',
    CountryCode: 'BZ',
    CurrencyName: 'Belize Dollar',
    CurrencySymbol: 'BZ$',
    CurrencyCode: 'BZD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Benin',
    CountryCode: 'BJ',
    CurrencyName: 'CFA Franc BCEAO',
    CurrencySymbol: 'CFA',
    CurrencyCode: 'XOF',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Bermuda',
    CountryCode: 'BM',
    CurrencyName: 'Bermudian Dollar',
    CurrencySymbol: 'BD$',
    CurrencyCode: 'BMD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Bonaire, Saint Eustatius and Saba',
    CountryCode: 'BQ',
    CurrencyName: 'US Dollar',
    CurrencySymbol: '$',
    CurrencyCode: 'USD',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Bosnia and Herzegovina',
    CountryCode: 'BA',
    CurrencyName: 'Convertible Mark',
    CurrencySymbol: 'KM',
    CurrencyCode: 'BAM',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Botswana',
    CountryCode: 'BW',
    CurrencyName: 'Pula',
    CurrencySymbol: 'BWP',
    CurrencyCode: 'BWP',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'British Virgin Islands',
    CountryCode: 'VG',
    CurrencyName: 'US Dollar',
    CurrencySymbol: '$',
    CurrencyCode: 'USD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Brunei Darussalam',
    CountryCode: 'BN',
    CurrencyName: 'Brunei Dollar',
    CurrencySymbol: 'BN$',
    CurrencyCode: 'BND',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Burkina Faso',
    CountryCode: 'BF',
    CurrencyName: 'CFA Franc BCEAO',
    CurrencySymbol: 'CFA',
    CurrencyCode: 'XOF',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Burundi',
    CountryCode: 'BI',
    CurrencyName: 'Burundi Franc',
    CurrencySymbol: 'FBu',
    CurrencyCode: 'BIF',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Cambodia',
    CountryCode: 'KH',
    CurrencyName: 'Riel',
    CurrencySymbol: 'KHR',
    CurrencyCode: 'KHR',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Cameroon',
    CountryCode: 'CM',
    CurrencyName: 'CFA Franc BEAC',
    CurrencySymbol: 'XAF',
    CurrencyCode: 'XAF',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryCode: 'CA',
    icon: 'icoking-cad',
    CurrencyCode: 'CAD',
    CountryName: 'Canada',
    CultureProgId: 'en-GB',
  },
  {
    CountryName: 'Cayman Islands',
    CountryCode: 'KY',
    CurrencyName: 'Cayman Islands Dollar',
    CurrencySymbol: 'KY$',
    CurrencyCode: 'KYD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Chad',
    CountryCode: 'TD',
    CurrencyName: 'CFA Franc BEAC',
    CurrencySymbol: 'XAF',
    CurrencyCode: 'XAF',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Congo',
    CountryCode: 'CG',
    CurrencyName: 'CFA Franc BEAC',
    CurrencySymbol: 'XAF',
    CurrencyCode: 'XAF',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Cook Islands',
    CountryCode: 'CK',
    CurrencyName: 'New Zealand Dollar',
    CurrencySymbol: 'NZ$',
    CurrencyCode: 'NZD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Costa Rica',
    CountryCode: 'CR',
    CurrencyName: 'Costa Rican Colon',
    CurrencySymbol: '?',
    CurrencyCode: 'CRC',
    CultureProgId: 'es',
    CultureName: 'Spanish',
  },
  {
    CountryName: "Cote D'Ivoire (Ivory Coast)",
    CountryCode: 'CI',
    CurrencyName: 'CFA Franc BCEAO',
    CurrencySymbol: 'CFA',
    CurrencyCode: 'XOF',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Curacao',
    CountryCode: 'CW',
    CurrencyName: 'Netherlands Antillean Guilder',
    CurrencySymbol: 'NAf.',
    CurrencyCode: 'ANG',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Cyprus',
    CountryCode: 'CY',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Czech Republic',
    CountryCode: 'CZ',
    CurrencyName: 'Czech Koruna',
    CurrencySymbol: 'K?',
    CurrencyCode: 'CZK',
    CultureProgId: 'cs',
    CultureName: 'Czech',
  },
  {
    CountryName: 'Denmark',
    CountryCode: 'DK',
    CurrencyName: 'Danish Krone',
    CurrencySymbol: 'kr',
    CurrencyCode: 'DKK',
    CultureProgId: 'da',
    CultureName: 'Danish',
  },
  {
    CountryName: 'Djibouti',
    CountryCode: 'DJ',
    CurrencyName: 'Djibouti Franc',
    CurrencySymbol: 'Fdj',
    CurrencyCode: 'DJF',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Dominican Republic',
    CountryCode: 'DO',
    CurrencyName: 'Dominican Peso',
    CurrencySymbol: 'RD$',
    CurrencyCode: 'DOP',
    CultureProgId: 'es',
    CultureName: 'Spanish',
  },
  {
    CountryName: 'East Timor',
    CountryCode: 'TL',
    CurrencyName: 'US Dollar',
    CurrencySymbol: '$',
    CurrencyCode: 'USD',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'El Salvador',
    CountryCode: 'SV',
    CurrencyName: 'US Dollar',
    CurrencySymbol: '$',
    CurrencyCode: 'USD',
    CultureProgId: 'es',
    CultureName: 'Spanish',
  },
  {
    CountryName: 'Estonia',
    CountryCode: 'EE',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Ethiopia',
    CountryCode: 'ET',
    CurrencyName: 'Ethiopian Birr',
    CurrencySymbol: 'Br',
    CurrencyCode: 'ETB',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Faroe Islands',
    CountryCode: 'FO',
    CurrencyName: 'Danish Krone',
    CurrencySymbol: 'kr',
    CurrencyCode: 'DKK',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Fiji',
    CountryCode: 'FJ',
    CurrencyName: 'Fiji Dollar',
    CurrencySymbol: 'FJ$',
    CurrencyCode: 'FJD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Finland',
    CountryCode: 'FI',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'fi',
    CultureName: 'Finnish',
  },
  {
    CountryName: 'French Guiana',
    CountryCode: 'GF',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'French Polynesia',
    CountryCode: 'PF',
    CurrencyName: 'CFP Franc',
    CurrencySymbol: 'CFPF',
    CurrencyCode: 'XPF',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Gabon',
    CountryCode: 'GA',
    CurrencyName: 'CFA Franc BEAC',
    CurrencySymbol: 'XAF',
    CurrencyCode: 'XAF',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Gambia',
    CountryCode: 'GM',
    CurrencyName: 'Dalasi',
    CurrencySymbol: 'GMD',
    CurrencyCode: 'GMD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Georgia',
    CountryCode: 'GE',
    CurrencyName: 'Lari',
    CurrencySymbol: 'GEL',
    CurrencyCode: 'GEL',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Germany',
    CountryCode: 'DE',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'de',
    CultureName: 'German',
  },
  {
    CountryName: 'Ghana',
    CountryCode: 'GH',
    CurrencyName: 'Ghana Cedi',
    CurrencySymbol: 'GH?',
    CurrencyCode: 'GHS',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Gibraltar',
    CountryCode: 'GI',
    CurrencyName: 'Pound Sterling',
    CurrencySymbol: '�',
    CurrencyCode: 'GBP',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Greece',
    CountryCode: 'GR',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'el',
    CultureName: 'Greek',
  },
  {
    CountryName: 'Greenland',
    CountryCode: 'GL',
    CurrencyName: 'Danish Krone',
    CurrencySymbol: 'kr',
    CurrencyCode: 'DKK',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Grenada',
    CountryCode: 'GD',
    CurrencyName: 'East Caribbean Dollar',
    CurrencySymbol: 'EC$',
    CurrencyCode: 'XCD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Guadeloupe',
    CountryCode: 'GP',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Guam',
    CountryCode: 'GU',
    CurrencyName: 'US Dollar',
    CurrencySymbol: '$',
    CurrencyCode: 'USD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Guernsey',
    CountryCode: 'GG',
    CurrencyName: 'Pound Sterling',
    CurrencySymbol: '�',
    CurrencyCode: 'GBP',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Guinea',
    CountryCode: 'GN',
    CurrencyName: 'Guinea Franc',
    CurrencySymbol: 'FG',
    CurrencyCode: 'GNF',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Guyana',
    CountryCode: 'GY',
    CurrencyName: 'Guyana Dollar',
    CurrencySymbol: 'GY$',
    CurrencyCode: 'GYD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Haiti',
    CountryCode: 'HT',
    CurrencyName: 'Gourde',
    CurrencySymbol: 'HTG',
    CurrencyCode: 'HTG',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Honduras',
    CountryCode: 'HN',
    CurrencyName: 'Lempira',
    CurrencySymbol: 'HNL',
    CurrencyCode: 'HNL',
    CultureProgId: 'es',
    CultureName: 'Spanish',
  },
  {
    CountryName: 'Hong Kong',
    CountryCode: 'HK',
    CurrencyName: 'Hong Kong Dollar',
    CurrencySymbol: 'HK$',
    CurrencyCode: 'HKD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Iceland',
    CountryCode: 'IS',
    CurrencyName: 'Iceland Krona',
    CurrencySymbol: 'kr',
    CurrencyCode: 'ISK',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Ireland (Republic of)',
    CountryCode: 'IE',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Isle of Man',
    CountryCode: 'IM',
    CurrencyName: 'Pound Sterling',
    CurrencySymbol: '�',
    CurrencyCode: 'GBP',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Israel',
    CountryCode: 'IL',
    CurrencyName: 'Israeli Shekel',
    CurrencySymbol: '?',
    CurrencyCode: 'ILS',
    CultureProgId: 'he',
    CultureName: 'Hebrew',
  },
  {
    CountryName: 'Italy',
    CountryCode: 'IT',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'it',
    CultureName: 'Italian',
  },
  {
    CountryName: 'Japan',
    CountryCode: 'JP',
    CurrencyName: 'Yen',
    CurrencySymbol: '�',
    CurrencyCode: 'JPY',
    CultureProgId: 'ja',
    CultureName: 'Japanese',
  },
  {
    CountryName: 'Jersey',
    CountryCode: 'JE',
    CurrencyName: 'Pound Sterling',
    CurrencySymbol: '�',
    CurrencyCode: 'GBP',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Kazakhstan',
    CountryCode: 'KZ',
    CurrencyName: 'Tenge',
    CurrencySymbol: 'KZT',
    CurrencyCode: 'KZT',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Kenya',
    CountryCode: 'KE',
    CurrencyName: 'Kenyan Shilling',
    CurrencySymbol: 'KSh',
    CurrencyCode: 'KES',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Korea (South)',
    CountryCode: 'KR',
    CurrencyName: 'Won',
    CurrencySymbol: '?',
    CurrencyCode: 'KRW',
    CultureProgId: 'ko-KR',
    CultureName: 'Korean - Korea',
  },
  {
    CountryName: 'Kyrgyzstan',
    CountryCode: 'KG',
    CurrencyName: 'Som',
    CurrencySymbol: 'KGS',
    CurrencyCode: 'KGS',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Laos',
    CountryCode: 'LA',
    CurrencyName: 'Kip',
    CurrencySymbol: '?',
    CurrencyCode: 'LAK',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Latvia',
    CountryCode: 'LV',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Lebanon',
    CountryCode: 'LB',
    CurrencyName: 'Lebanese Pound',
    CurrencySymbol: 'LBP',
    CurrencyCode: 'LBP',
    CultureProgId: 'ar',
    CultureName: 'Arabic',
  },
  {
    CountryName: 'Lesotho',
    CountryCode: 'LS',
    CurrencyName: 'Loti',
    CurrencySymbol: 'LSL',
    CurrencyCode: 'LSL',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Liberia',
    CountryCode: 'LR',
    CurrencyName: 'Liberian Dollar',
    CurrencySymbol: 'L$',
    CurrencyCode: 'LRD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Liechtenstein',
    CountryCode: 'LI',
    CurrencyName: 'Swiss Franc',
    CurrencySymbol: 'CHF',
    CurrencyCode: 'CHF',
    CultureProgId: 'de',
    CultureName: 'German',
  },
  {
    CountryName: 'Lithuania',
    CountryCode: 'LT',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Luxembourg',
    CountryCode: 'LU',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Macau',
    CountryCode: 'MO',
    CurrencyName: 'Pataca',
    CurrencySymbol: 'MOP$',
    CurrencyCode: 'MOP',
    CultureProgId: 'zh-CHS',
    CultureName: 'Chinese (Simplified)',
  },
  {
    CountryName: 'Malawi',
    CountryCode: 'MW',
    CurrencyName: 'Kwacha',
    CurrencySymbol: 'MWK',
    CurrencyCode: 'MWK',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Malaysia',
    CountryCode: 'MY',
    CurrencyName: 'Malaysian Ringgit',
    CurrencySymbol: 'RM',
    CurrencyCode: 'MYR',
    CultureProgId: 'ms',
    CultureName: 'Malay',
  },
  {
    CountryName: 'Maldives',
    CountryCode: 'MV',
    CurrencyName: 'Rufiyaa',
    CurrencySymbol: 'MVR',
    CurrencyCode: 'MVR',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Marshall Islands',
    CountryCode: 'MH',
    CurrencyName: 'US Dollar',
    CurrencySymbol: '$',
    CurrencyCode: 'USD',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Martinique',
    CountryCode: 'MQ',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Mauritania',
    CountryCode: 'MR',
    CurrencyName: 'Mauritanian ouguiya',
    CurrencySymbol: 'UM',
    CurrencyCode: 'MRU',
    CultureProgId: 'ar',
    CultureName: 'Arabic',
  },
  {
    CountryName: 'Mauritius',
    CountryCode: 'MU',
    CurrencyName: 'Mauritius Rupee',
    CurrencySymbol: 'MURs',
    CurrencyCode: 'MUR',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Micronesia',
    CountryCode: 'FM',
    CurrencyName: 'US Dollar',
    CurrencySymbol: '$',
    CurrencyCode: 'USD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Moldova',
    CountryCode: 'MD',
    CurrencyName: 'Moldovan Leu',
    CurrencySymbol: 'MDL',
    CurrencyCode: 'MDL',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Mongolia',
    CountryCode: 'MN',
    CurrencyName: 'Tugrik',
    CurrencySymbol: '?',
    CurrencyCode: 'MNT',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Montenegro',
    CountryCode: 'ME',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Morocco',
    CountryCode: 'MA',
    CurrencyName: 'Moroccan Dirham',
    CurrencySymbol: 'MAD',
    CurrencyCode: 'MAD',
    CultureProgId: 'ar',
    CultureName: 'Arabic',
  },
  {
    CountryName: 'Mozambique',
    CountryCode: 'MZ',
    CurrencyName: 'Mozambique Metical',
    CurrencySymbol: 'MTn',
    CurrencyCode: 'MZN',
    CultureProgId: 'pt',
    CultureName: 'Portuguese',
  },
  {
    CountryName: 'Namibia',
    CountryCode: 'NA',
    CurrencyName: 'Namibia Dollar',
    CurrencySymbol: 'N$',
    CurrencyCode: 'NAD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Nepal',
    CountryCode: 'NP',
    CurrencyName: 'Nepalese Rupee',
    CurrencySymbol: 'NPRs',
    CurrencyCode: 'NPR',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Netherlands',
    CountryCode: 'NL',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'nl-NL',
    CultureName: 'Dutch - The Netherlands',
  },
  {
    CountryName: 'Netherlands Antilles',
    CountryCode: 'AN',
    CurrencyName: 'Netherlands Antillean Guilder',
    CurrencySymbol: 'NAf.',
    CurrencyCode: 'ANG',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'New Zealand',
    CountryCode: 'NZ',
    CurrencyName: 'New Zealand Dollar',
    CurrencySymbol: 'NZ$',
    CurrencyCode: 'NZD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Nicaragua',
    CountryCode: 'NI',
    CurrencyName: 'Cordoba Oro',
    CurrencySymbol: 'NIO',
    CurrencyCode: 'NIO',
    CultureProgId: 'es',
    CultureName: 'Spanish',
  },
  {
    CountryName: 'Nigeria',
    CountryCode: 'NG',
    CurrencyName: 'Naira',
    CurrencySymbol: '?',
    CurrencyCode: 'NGN',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'North Macedonia',
    CountryCode: 'MK',
    CurrencyName: 'Denar',
    CurrencySymbol: 'MKD',
    CurrencyCode: 'MKD',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Northern Mariana Islands',
    CountryCode: 'MP',
    CurrencyName: 'US Dollar',
    CurrencySymbol: '$',
    CurrencyCode: 'USD',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Norway',
    CountryCode: 'NO',
    CurrencyName: 'Norwegian Krone',
    CurrencySymbol: 'kr',
    CurrencyCode: 'NOK',
    CultureProgId: 'no',
    CultureName: 'Norwegian',
  },
  {
    CountryName: 'Oman',
    CountryCode: 'OM',
    CurrencyName: 'Rial Omani',
    CurrencySymbol: 'OMR',
    CurrencyCode: 'OMR',
    CultureProgId: 'ar',
    CultureName: 'Arabic',
  },
  {
    CountryName: 'Pakistan',
    CountryCode: 'PK',
    CurrencyName: 'Pakistan Rupee',
    CurrencySymbol: 'Rs',
    CurrencyCode: 'PKR',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Palau',
    CountryCode: 'PW',
    CurrencyName: 'US Dollar',
    CurrencySymbol: '$',
    CurrencyCode: 'USD',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Panama',
    CountryCode: 'PA',
    CurrencyName: 'US Dollar',
    CurrencySymbol: '$',
    CurrencyCode: 'USD',
    CultureProgId: 'es',
    CultureName: 'Spanish',
  },
  {
    CountryName: 'Papua New Guinea',
    CountryCode: 'PG',
    CurrencyName: 'Kina',
    CurrencySymbol: 'PGK',
    CurrencyCode: 'PGK',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Philippines',
    CountryCode: 'PH',
    CurrencyName: 'Philippine Peso',
    CurrencySymbol: '?',
    CurrencyCode: 'PHP',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Poland',
    CountryCode: 'PL',
    CurrencyName: 'Zloty',
    CurrencySymbol: 'z?',
    CurrencyCode: 'PLN',
    CultureProgId: 'pl',
    CultureName: 'Polish',
  },
  {
    CountryName: 'Puerto Rico',
    CountryCode: 'PR',
    CurrencyName: 'US Dollar',
    CurrencySymbol: '$',
    CurrencyCode: 'USD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Qatar',
    CountryCode: 'QA',
    CurrencyName: 'Qatari riyal',
    CurrencySymbol: 'QR',
    CurrencyCode: 'QAR',
    CultureProgId: 'ar',
    CultureName: 'Arabic',
  },
  {
    CountryName: 'Reunion',
    CountryCode: 'RE',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Rwanda',
    CountryCode: 'RW',
    CurrencyName: 'Rwanda Franc',
    CurrencySymbol: 'RWF',
    CurrencyCode: 'RWF',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Saint Kitts and Nevis',
    CountryCode: 'KN',
    CurrencyName: 'East Caribbean Dollar',
    CurrencySymbol: 'EC$',
    CurrencyCode: 'XCD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Samoa',
    CountryCode: 'WS',
    CurrencyName: 'Tala',
    CurrencySymbol: 'WS$',
    CurrencyCode: 'WST',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Senegal',
    CountryCode: 'SN',
    CurrencyName: 'CFA Franc BCEAO',
    CurrencySymbol: 'CFA',
    CurrencyCode: 'XOF',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Serbia',
    CountryCode: 'RS',
    CurrencyName: 'Serbian Dinar',
    CurrencySymbol: 'din.',
    CurrencyCode: 'RSD',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Singapore',
    CountryCode: 'SG',
    CurrencyName: 'Singapore Dollar',
    CurrencySymbol: 'S$',
    CurrencyCode: 'SGD',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Sint Maarten',
    CountryCode: 'SX',
    CurrencyName: 'Netherlands Antillean Guilder',
    CurrencySymbol: 'NAf.',
    CurrencyCode: 'ANG',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Slovenia',
    CountryCode: 'SI',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Spain',
    CountryCode: 'ES',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'es',
    CultureName: 'Spanish',
  },
  {
    CountryName: 'Sri Lanka',
    CountryCode: 'LK',
    CurrencyName: 'Sri Lanka Rupee',
    CurrencySymbol: 'SLRs',
    CurrencyCode: 'LKR',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'St Martin',
    CountryCode: 'MF',
    CurrencyName: 'Euro',
    CurrencySymbol: '�',
    CurrencyCode: 'EUR',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Suriname',
    CountryCode: 'SR',
    CurrencyName: 'Surinam Dollar',
    CurrencySymbol: 'SR$',
    CurrencyCode: 'SRD',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Swaziland',
    CountryCode: 'SZ',
    CurrencyName: 'Lilangeni',
    CurrencySymbol: 'SZL',
    CurrencyCode: 'SZL',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Sweden',
    CountryCode: 'SE',
    CurrencyName: 'Swedish Krona',
    CurrencySymbol: 'kr',
    CurrencyCode: 'SEK',
    CultureProgId: 'sv',
    CultureName: 'Swedish',
  },
  {
    CountryName: 'Taiwan',
    CountryCode: 'TW',
    CurrencyName: 'New Taiwan Dollar',
    CurrencySymbol: 'NT$',
    CurrencyCode: 'TWD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Tanzania',
    CountryCode: 'TZ',
    CurrencyName: 'Tanzanian Shilling',
    CurrencySymbol: 'TSh',
    CurrencyCode: 'TZS',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Thailand',
    CountryCode: 'TH',
    CurrencyName: 'Baht',
    CurrencySymbol: '?',
    CurrencyCode: 'THB',
    CultureProgId: 'th',
    CultureName: 'Thai',
  },
  {
    CountryName: 'Togo',
    CountryCode: 'TG',
    CurrencyName: 'CFA Franc BCEAO',
    CurrencySymbol: 'CFA',
    CurrencyCode: 'XOF',
    CultureProgId: 'fr',
    CultureName: 'French',
  },
  {
    CountryName: 'Tonga',
    CountryCode: 'TO',
    CurrencyName: 'Pa�anga',
    CurrencySymbol: 'T$',
    CurrencyCode: 'TOP',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Tunisia',
    CountryCode: 'TN',
    CurrencyName: 'Tunisian Dinar',
    CurrencySymbol: 'DT',
    CurrencyCode: 'TND',
    CultureProgId: 'ar',
    CultureName: 'Arabic',
  },
  {
    CountryName: 'Turkmenistan',
    CountryCode: 'TM',
    CurrencyName: 'Turkmenistan New Manat',
    CurrencySymbol: 'TMT',
    CurrencyCode: 'TMT',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Turks and Caicos Islands',
    CountryCode: 'TC',
    CurrencyName: 'US Dollar',
    CurrencySymbol: '$',
    CurrencyCode: 'USD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Uganda',
    CountryCode: 'UG',
    CurrencyName: 'Uganda Shilling',
    CurrencySymbol: 'USh',
    CurrencyCode: 'UGX',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'United Arab Emirates',
    CountryCode: 'AE',
    CurrencyName: 'UAE Dirham',
    CurrencySymbol: 'AED',
    CurrencyCode: 'AED',
    CultureProgId: 'ar',
    CultureName: 'Arabic',
  },
  {
    CountryName: 'United Kingdom',
    CountryCode: 'GB',
    CurrencyName: 'Pound Sterling',
    CurrencySymbol: '�',
    CurrencyCode: 'GBP',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryCode: 'US',
    icon: 'icoking-usd',
    CurrencyCode: 'USD',
    CountryName: 'United States',
    CultureProgId: 'en-US',
    CultureName: 'English - United States',
  },
  {
    CountryName: 'Uzbekistan',
    CountryCode: 'UZ',
    CurrencyName: 'Uzbekistan Sum',
    CurrencySymbol: 'UZS',
    CurrencyCode: 'UZS',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Vanuatu',
    CountryCode: 'VU',
    CurrencyName: 'Vatu',
    CurrencySymbol: 'VT',
    CurrencyCode: 'VUV',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Vietnam',
    CountryCode: 'VN',
    CurrencyName: 'Dong',
    CurrencySymbol: '?',
    CurrencyCode: 'VND',
    CultureProgId: 'vi',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Wallis and Futuna Islands',
    CountryCode: 'WF',
    CurrencyName: 'CFP Franc',
    CurrencySymbol: 'CFPF',
    CurrencyCode: 'XPF',
    CultureProgId: 'en-GB',
    CultureName: 'Undefined',
  },
  {
    CountryName: 'Zambia',
    CountryCode: 'ZM',
    CurrencyName: 'Zambian Kwacha',
    CurrencySymbol: 'ZMW',
    CurrencyCode: 'ZMW',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
  {
    CountryName: 'Zimbabwe',
    CountryCode: 'ZW',
    CurrencyName: 'US Dollar',
    CurrencySymbol: '$',
    CurrencyCode: 'USD',
    CultureProgId: 'en-GB',
    CultureName: 'English - United Kingdom',
  },
];
